import { render, staticRenderFns } from "./new-team-modal.vue?vue&type=template&id=d6d945d4&scoped=true"
import script from "./new-team-modal.vue?vue&type=script&lang=js"
export * from "./new-team-modal.vue?vue&type=script&lang=js"
import style0 from "./new-team-modal.vue?vue&type=style&index=0&id=d6d945d4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d945d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6d945d4')) {
      api.createRecord('d6d945d4', component.options)
    } else {
      api.reload('d6d945d4', component.options)
    }
    module.hot.accept("./new-team-modal.vue?vue&type=template&id=d6d945d4&scoped=true", function () {
      api.rerender('d6d945d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/club-teams/modals/new-team-modal/new-team-modal.vue"
export default component.exports